import { RESET_ALL_ACCOUNT_STATE_DEPEN } from "../../actions/commonActions";
import { FETCH_SPOT_CONTACTS_FAILURE, FETCH_SPOT_CONTACTS_REQUEST, FETCH_SPOT_CONTACTS_SUCCESS } from "../../actions/targetedReachout/spotContactsActions";

  const initialState = {
    spotContactsLoading: true,
    spotContactsData: [],
    spotContactsError: null,
  };
  
  const spotContactsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_SPOT_CONTACTS_REQUEST:
        return { ...state, spotContactsLoading: true , payload: action.payload};
      case FETCH_SPOT_CONTACTS_SUCCESS:
        return { ...state, spotContactsLoading: false, spotContactsData: action.payload };
      case FETCH_SPOT_CONTACTS_FAILURE:
        return { ...state, spotContactsLoading: false, spotContactsError: action.payload };     
      case RESET_ALL_ACCOUNT_STATE_DEPEN:
              return initialState       
      default:
        return state;
    }
  };
  
  export default spotContactsReducer;
  
